import PropTypes from 'prop-types';

import seatMapRowShape from './seatMapRowShape';

export default PropTypes.shape({
  rows: PropTypes.arrayOf(seatMapRowShape),
});
